import React from 'react';

/* Minimal text-based logo strip — Stripe/Notion style restraint */
const PARTNERS = ['NEWSLY.GLOBAL', 'AUTHORITY GRAPH', 'AGENTIC SWARM', 'AI-DISCOVERY READY', 'ENTITY ENGINE', 'KNOWLEDGE GRAPH'];

export default function LogoStrip() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 opacity-70">
      {PARTNERS.map(p => (
        <span key={p} className="font-display text-xs tracking-[0.2em] text-muted-foreground">
          {p}
        </span>
      ))}
    </div>
  );
}
